import { Injectable } from '@angular/core';
import { CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { URLADDRESS } from '../../shared/data/url';
import { RouteService } from '../services/route-service/route-service';
import { SecurityService } from '../services/security.service';

@Injectable()
export class FrontPageAuthGuard implements CanActivate {
  constructor(private router: RouteService,
    private securityService: SecurityService) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.securityService.IsUserLogin) {
      return true;
    }
    else {
      URLADDRESS.address = state.url;
      this.router.gotoHome();
      if (route) {
        route = null;
      }
      return false;

    }

  }
}
